export const styleInputSelect = {
    valueContainer: base => ({
        ...base,
        minHeight: '46px'
      })
};